module.exports = __webpack_public_path__ + "img/dai5.ecd170d2.png";